import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import productsData from '../data/products.json';
import './Home.css';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ScienceIcon from "@mui/icons-material/Science";
import PublicIcon from "@mui/icons-material/Public";
import ContactMaterials from '../components/ContactMaterials';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const featured = productsData.products.slice(0, 6);
      setFeaturedProducts(featured);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="">

      {/* ── Hero Section ───────────────────────────────────────────── */}
      <section className="" style={{
        backgroundImage: `url('/header.png')`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'cover',
      }}>
        <div className="container">
          <div className="hero-content">
            <span className="hero-badge">Trusted Electrical Partner Since 2014</span>
            <h1 className="hero-title">
              Precision Silver Contact<br />
              <span className="hero-highlight">Bimetal Rivet Manufacturer</span>
            </h1>
            <p className="hero-subtitle">
              Supply High Performance Electrical Contact Solution to OEMs in India & Global Markets
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary btn-lg">
                Request Quotation
              </Link>
              <Link to="/products" className="btn btn-secondary btn-lg">
                View Products
              </Link>
            </div>
            <br />
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Products</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="stat-number">10K+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="stat-number">35+</span>
                <span className="stat-label">Years Experience</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Features Strip ─────────────────────────────────────────── */}
      <section className="features-strip">
        <div className="container">
          <div className="features-strip-grid">
            <div className="strip-item">
              <span><CheckCircleIcon className="strip-icon green" /></span>
              <div>
                <h4>ISO 9001 Certified Manufacturing</h4>
                <p>All products quality checked</p>
              </div>
            </div>
            <div className="strip-item">
              <span><EngineeringIcon className="strip-icon yellow" /></span>
              <div>
                <h4>OEM & Custom Contact Development</h4>
                <p>Inside the Delhi</p>
              </div>
            </div>
            <div className="strip-item">
              <span><ScienceIcon className="strip-icon gray" /></span>
              <div>
                <h4>Tested for Composition & Hardness</h4>
                <p>7-day hassle-free returns</p>
              </div>
            </div>
            <div className="strip-item">
              <span><PublicIcon className="strip-icon orange" /></span>
              <div>
                <h4>Pan-India Industrial Supply</h4>
                <p>Sun–Sat, 9 AM–6 PM</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── About Section ──────────────────────────────────────────── */}
      <section className="about-intro">
        <div className="container">
          <div className="intro-grid">
            <div className="intro-image">
              <div className="intro-image-placeholder">
                <span><img src="/logo.png" alt='about logo' className="about-logo-img" /></span>
              </div>
            </div>
            <div className="about-text-col">
              <span className="section-label">About gad</span>
              <h2 className="section-heading">Your Trusted Electrical<br />Solutions Partner</h2>
              <p className="about-description">
                G.A.D. Electrical Industries is an ISO 9001:2015 certified manufacturer of high-precision electrical contact
                components based in New Delhi. We specialize in bimetal contact rivets, silver alloy contacts,
                and copper rivets for switchgear and electrical applications. We have been providing high-quality electrical products and
                solutions to residential, commercial, and industrial customers across India.
              </p>
              <div className="about-highlights">
                <div className="highlight-item">
                  <span className="highlight-check">✓</span>
                  ISO Certified.
                </div>
                <div className="highlight-item">
                  <span className="highlight-check">✓</span>
                  Authorised Multi-Brand Distributor
                </div>
                <div className="highlight-item">
                  <span className="highlight-check">✓</span>
                  Pan-India Delivery Network
                </div>
                <div className="highlight-item">
                  <span className="highlight-check">✓</span>
                  Dedicated After-Sales Support
                </div>
              </div>
              <Link to="/about" className="btn btn-primary">
                Know More About Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Available Contact Materials ─────────────────────────────── */}
      <section className="features-strip">
        <div className="container">
          <h1 className='section-heading center'>Available Contact Materials</h1>
          <div className="">
            <ContactMaterials />
          </div>
        </div>
      </section>

      {/* ── Featured Products Section ──────────────────────────────── */}
      <section className="featured-section">
        <div className="container">
          <span className="section-label center">Best Sellers</span>
          <h2 className="section-heading center">Our Products</h2>
          <p className="section-subtitle">Explore our top-rated electrical products trusted by thousands of customers</p>
          <div className="products-grid grid grid-3">
            {featuredProducts.map(product => (
              <ProductCard
                key={product.id}
                product={product}
              />
            ))}
          </div>
          <div className="view-all-container">
            <Link to="/products" className="btn btn-outline">
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ──────────────────────────────────────────── */}
      <section className="why-section">
        <div className="container">
          <span className="section-label center light">Why G.A.D</span>
          <h2 className="section-heading center light">Why Choose Us</h2>
          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon">🏆</div>
              <h3>Precision Manufacturing</h3>
              <p>
                Every contact rivet is manufactured with strict dimensional tolerance, controlled metallurgy, and advanced quality inspection to ensure consistent performance.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">💰</div>
              <h3>Cost-Optimized Production</h3>
              <p>
                In-house manufacturing and efficient material sourcing allow us to deliver competitive pricing without compromising silver composition or electrical reliability.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">🔧</div>
              <h3>Technical Engineering Support</h3>
              <p>
                Our technical team assists OEMs in selecting the right material grade (AgCdO, AgNi, AgSnO₂, AgCu, Bimetal) for optimal switching life and conductivity.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">🚀</div>
              <h3>Fast & Reliable Dispatch</h3>
              <p>
                Strong production planning and stock management enable timely deliveries across India with secure industrial-grade packaging.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">🤝</div>
              <h3>Trusted OEM Partner</h3>
              <p>
                Supplying to leading modular switch and MCB manufacturers with strict confidentiality and long-term business relationships.
              </p>
            </div>
            <div className="why-card">
              <div className="why-icon">🛡️</div>
              <h3>Quality Assurance & Traceability</h3>
              <p>
                Each batch is tested for composition, hardness, grain structure, and electrical performance with full material traceability.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;